import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { firstValueFrom } from 'rxjs';
import { UnidadesEmpresaService } from '../../../services/unidades-empresa.service';
import { ModalCadastroComponent } from '../../../shared/modal-cadastro/modal-cadastro.component';
import { MessageService } from '@services';
import { getErrorMessage } from '@utils';

@Component({
  selector: 'app-atualizar-crt',
  templateUrl: './atualizar-crt.component.html',
  styleUrls: ['./atualizar-crt.component.css']
})
export class AtualizarCrtComponent extends ModalCadastroComponent implements OnInit {
  @ViewChild('modalCadastro', { static: true }) modalCadastro;

  crtOptions: any = [
    { id: 1, name: 'Simples Nacional' },
    { id: 2, name: 'Simples Nacional - excesso de sublimite de receita bruta' },
    { id: 3, name: 'Normal' },
    { id: 4, name: 'MEI' },
  ];

  constructor(
    private unidadesEmpresaService: UnidadesEmpresaService,
    private messageService: MessageService,
  ) {
    super();

    this.cadastroForm = new FormGroup({
      crt: new FormControl(null, [Validators.required]),
      regimePIS_COFINS: new FormControl(null),
    });
  }

  ngOnInit() {
    this.carregarDados();
  }

  async carregarDados() {
    try {
      this.loading = true;

      const res = await firstValueFrom(this.unidadesEmpresaService.getUnidadeEmpresa());
      this.cadastroForm.get('crt').setValue(res.crt);
      this.cadastroForm.get('regimePIS_COFINS').setValue(res.regimePIS_COFINS);
    } catch (err) {
      this.messageService.error('Falha ao carregar os dados: ' + getErrorMessage(err), 8000);
    } finally {
      this.loading = false;
    }
  }

  async submit() {
    this.messageService.clearAll();
    this.validaForm();
    if (!this.cadastroForm.valid) {
      this.loading = false;
      return;
    }

    if (this.cadastroForm.get('crt').value === 3 && !this.cadastroForm.get('regimePIS_COFINS').value) {
      this.messageService.error('Obrigatório selecionar o regime PIS/COFINS', 8000);
      return;
    }

    try {
      this.loading = true;
      if (this.cadastroForm.get('crt').value !== 3) {
        this.cadastroForm.get('regimePIS_COFINS').setValue(null);
      }
      
      await firstValueFrom(this.unidadesEmpresaService.atualizarCrt(this.cadastroForm.getRawValue()));
      this.messageService.success('Dados salvos com sucesso!', 5000);
      this.modalCadastro.hide();
    } catch (err) {
      this.messageService.error(getErrorMessage(err), 8000);
    } finally {
      this.loading = false;
    }
  }

  show() {
    this.modalCadastro.show();
  }

  destroyComponent() {
    this.closed.emit();
  }
}
